import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
// 非遗定制弹窗  数据对接非遗项目
import { handleHttp, loadScript, locationHandle, setImgsize } from "@/utils/utils";
import QRCode from 'qrcodejs2';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  data() {
    return {
      detail: {},
      person: [],
      timer: null,
      linkcontainerflag: false,
      iframeurl: '',
      routeflag: false,
      popLeftIndex: 0,
      popLeftArr: [{
        name: '简介',
        id: 0,
        flag: true
      }, {
        name: '传承人',
        id: 1,
        flag: false
      }, {
        name: '图片',
        id: 2,
        flag: false
      }, {
        name: '视频',
        id: 3,
        flag: false
      }, {
        name: '传习所',
        id: 4,
        flag: false
      }],
      picture: [],
      videoList: [],
      videoitem: {},
      playiconshow: true,
      ewmflag: false,
      seminarList: [],
      leftTopflag: false,
      bigDialog: false,
      viewer: null
    };
  },
  components: {},
  computed: {
    popContainerStyle() {
      const coord = this.detail.pixelcoordinate;
      if (this.$attrs.isMobile || !coord || coord.length < 2) return {};
      return {
        position: 'fixed',
        left: !this.leftTopflag ? `${coord[0] - 4}px` : `${coord[0] - 418}px`,
        top: `${coord[1] - 75}px`,
        zIndex: 10
      };
    }
  },
  watch: {
    '$attrs.detail': {
      handler() {
        this.init();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  methods: {
    init() {
      const val = this.$attrs.detail;
      if (!val || Object.keys(val).length === 0) return;
      this.detail = val;
      this.popLeftArr.forEach((elem, index) => {
        if (index > 0) elem.flag = false;
      });
      this.person = [];
      this.picture = [];
      this.videoList = [];
      this.seminarList = [];
      if (val.pixelcoordinate && val.pixelcoordinate.length >= 2) {
        const popLeft = val.pixelcoordinate[0] + 414;
        this.leftTopflag = popLeft > document.body.clientWidth;
      } else {
        this.leftTopflag = false;
      }
      if (val.person) {
        this.person = val.person;
        this.popLeftArr[1].flag = true;
      }
      if (val.pictureList) {
        this.picture = [];
        if (this.$route.query.fid === '138053') {
          val.pictureList.forEach(elem => {
            this.picture.push(elem.itemformdata.img1[0]);
          });
        } else {
          val.pictureList[0].itemformdata[1].forEach(elem => {
            if (elem.values && elem.values[0]) this.picture.push(elem.values[0][0].fileUrl);
          });
        }
        this.popLeftArr[2].flag = true;
      }
      if (val.videoList) {
        this.popLeftArr[3].flag = true;
        this.videoList = [];
        if (this.$route.query.fid === '138053') {
          this.videoList = val.videoList[0].itemformdata.video;
          this.$api.getUrlByObjectId(val.videoList[0].itemformdata.video[0].objectId).then(res => {
            this.videoitem.url = res.http;
          });
        } else {
          this.videoList = val.videoList[0].itemformdata[5];
          this.$api.getUrlByObjectId(val.videoList[0].itemformdata[5][0].objectId).then(res => {
            this.videoitem.url = res.http;
          });
        }
      }
      if (val.seminarList) {
        this.seminarList = val.seminarList;
        this.popLeftArr[4].flag = true;
      }
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.detail = {};
      this.popLeftArr.forEach((elem, index) => {
        if (index > 0) elem.flag = false;
      });
      this.popLeftIndex = 0;
      this.picture = [];
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    getImg(val) {
      return setImgsize(val, 160, 228);
    },
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    openUrl(url) {
      window.open(url);
    },
    changevideo() {
      this.$refs.videoDom.play();
      this.playiconshow = false;
    },
    goLocation() {
      let details = {
        placeName: this.detail.correlation_address[0].address,
        linkTarget: '否',
        open: true
      };
      locationHandle.call(this, details, {
        route: this.detail.correlation_address
      });
      this.linkcontainerflag = false;
    },
    getCode() {
      this.ewmflag = true;
      new QRCode(this.$refs['qrcode-share'], {
        text: this.detail.detailUrl,
        // 扫二维码后获得的信息
        width: 280,
        // 图片宽90px，左右padding各4px，边框各1px， 100-8px-2px
        height: 280,
        // 图片高90px，上下padding各4px，边框各1px， 100-8px-2px
        correctLevel: 3
      });
    },
    bigDialogClose() {
      this.popLeftArr.forEach((elem, index) => {
        if (index > 0) elem.flag = false;
      });
      this.popLeftIndex = 0;
      this.picture = [];
      this.bigDialog = false;
    },
    bigDialogOpen() {
      this.bigDialog = true;
      let that = this;
      this.$nextTick(() => {
        let swipersmallEl = new Swiper(that.$refs.smallswiper, {
          initialSlide: 0,
          spaceBetween: 18,
          slidesPerView: 8,
          watchSlidesProgress: true,
          observeParents: true,
          observer: true
        });
        let swiperbigEl = new Swiper(that.$refs.bigswiper, {
          initialSlide: 0,
          // autoplay: true,
          observeSlideChildren: true,
          observeParents: true,
          observer: true,
          thumbs: {
            swiper: swipersmallEl
          }
        });
        this.$nextTick(() => {
          new Swiper(that.$refs.videosmallswiper, {
            initialSlide: 0,
            spaceBetween: 18,
            slidesPerView: 8,
            watchSlidesProgress: true,
            observeParents: true,
            observer: true
          });
        });
        // this.initViewer()
      });
    },
    setBigPicture(val) {
      return setImgsize(val, 800, 460);
    },
    setSmallPicture(val) {
      return setImgsize(val, 85, 105);
    },
    initViewer() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.destroy();
          this.viewer = null;
          return;
        }
        let that = this;
        this.viewer = new Viewer(document.querySelector('#showBigswiper'), {
          navbar: true,
          // 显示导航栏
          toolbar: {
            prev: true,
            next: true
          },
          // 显示工具栏
          title: false,
          viewed() {
            document.querySelector('.viewer-container').classList.add(`fid${that.$route.query.fid}pc`);
          }
        });
      });
    }
  }
};